import { useState } from 'react';
import { Burger, Group, Menu } from '@mantine/core';
import { useMedplum } from '@medplum/react';
import { IconLogout, IconUser, IconChevronDown } from '@tabler/icons-react';
import { useProfile } from '../../hooks/useProfile';
import { ProfileModal } from '../ProfileModal';

interface PortalHeaderProps {
  onBurgerClick: () => void;
  sidebarOpen: boolean;
}

export function PortalHeader({ onBurgerClick, sidebarOpen }: PortalHeaderProps) {
  const medplum = useMedplum();
  const { profileData } = useProfile();
  const [profileModalOpen, setProfileModalOpen] = useState(false);

  const handleLogout = async () => {
    await medplum.signOut();
    window.location.href = '/signin';
  };

  const displayName = profileData.firstName || profileData.email || 'User';

  return (
    <Group h="100%" px="md" justify="space-between">
      <Group>
        <Burger
          opened={sidebarOpen}
          onClick={onBurgerClick}
          hiddenFrom="sm"
          size="sm"
          color="var(--color-text-primary)"
        />
        <span className="text-lg font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
          Precision Longevity
        </span>
      </Group>

      <Menu
        shadow="md"
        width={200}
        position="bottom-end"
        styles={{
          dropdown: {
            backgroundColor: 'rgba(10, 15, 30, 0.95)',
            border: '1px solid rgba(0, 240, 255, 0.15)',
            backdropFilter: 'blur(12px)',
          },
          item: {
            color: 'var(--color-text-primary)',
            '&[data-hovered]': {
              backgroundColor: 'var(--color-bg-tertiary)',
            },
          },
        }}
      >
        <Menu.Target>
          <button className="flex items-center gap-2 px-3 py-2 text-sm text-gray-300 hover:text-gray-100 hover:bg-gray-800/50 rounded-md transition-colors">
            <IconUser size={18} />
            <span className="hidden sm:inline max-w-[150px] truncate">{displayName}</span>
            <IconChevronDown size={14} />
          </button>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item
            leftSection={<IconUser size={16} />}
            onClick={() => setProfileModalOpen(true)}
          >
            Edit Profile
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item
            leftSection={<IconLogout size={16} />}
            onClick={handleLogout}
            color="red"
          >
            Sign out
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      <ProfileModal
        opened={profileModalOpen}
        onClose={() => setProfileModalOpen(false)}
      />
    </Group>
  );
}
